import LoadingSpinner from "@/components/LoadingSpinner"
import { PdfCard, PdfType } from "@/pages/new-platform/components/PdfCard"
import { Exam } from "@/utils/api-objects/Exam"
import { MealPlanPdfType } from "@/utils/api-objects/HealthPlan"
import { getMealPlanPdfs } from "@/utils/apis/plan-service"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"


const MealPlanPdfsPage = () => {
  const { auth } = useAuthStore()
  const idToken = auth.idToken
  const userId = auth.userId
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const mealPlanId = searchParams.get("meal_plan_id");
  const type = searchParams.get("type");

  const navigate = useNavigate()

  const [isGeneralLoading, setIsGeneralLoading] = useState(true);

  const [pdfs, setPdfs] = useState<Exam[]>()

  const getMealPlanUrls = async () => {
    if (!userId || !idToken) return;

    const folder = `${mealPlanId}/${type}`;
    try {
      const urls = await getMealPlanPdfs(userId, idToken, folder)
      setPdfs(urls)
    } catch (error) {
      console.error(error);
    } finally {
      setIsGeneralLoading(false);
    }
  };

  useEffect(() => {
    getMealPlanUrls();
  }, []);

  if (isGeneralLoading || !pdfs) {
    return (
      <LoadingSpinner />
    );
  }

  return (
    <div className="w-full h-full flex flex-col space-y-[20px]">
      <div className="w-full space-y-[20px] pb-[20px]">
      {/* <div className="mt-[10px] space-y-[10px]"> */}
        {/* <BackButton
          text="Torna a Meal Plan"
          onClick={() => navigate("/health-plan/meal-plan")}
        /> */}
        <div className="font-bold text-[25px] leading-[35px]">
          {
            type === MealPlanPdfType.MealPlan ? "Dieta" : "A supporto del Meal Plan"
          }
        </div>
      {/* </div> */}
      <div className="w-full pb-[20px]">
        <div className="flex flex-col md:flex-row md:flex-wrap gap-4">
          {pdfs.map((pdf, index) => (
            <PdfCard key={index} exam={pdf} pdfType={type === MealPlanPdfType.MealPlan ? PdfType.Diet : PdfType.Uploads} />
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default MealPlanPdfsPage
